import { postEntities } from '~/api/entities/entity-service';
import { WatchlistData } from '~/stores/use-chat/assistant-response.type';

export const mapTagToTicker = async (
  tags: string[]
): Promise<Record<string, string>> => {
  const tickers: Record<string, string> = {};
  try {
    await Promise.all(
      tags.map(tag =>
        postEntities({
          filter: 2,
          args: [tag],
        })
      )
    ).then(r =>
      r.forEach(
        e =>
          e.data &&
          Object.assign(tickers, {
            [e.data[0].tag]: e.data[0].ticker.toUpperCase(),
          })
      )
    );
  } catch {
    return tickers;
  }
  return tickers;
};

export type MappedData = {
  entities: string;
  name: string;
  count: number;
  entitiesTags: string[];
};

export const mapData = async (data: WatchlistData): Promise<MappedData> => {
  let entities = '';
  let name = '';
  let count = 0;
  let entitiesTags: string[] = [];
  if ('info' in data && data.info) {
    entitiesTags = ('entities' in data.info && data.info.entities) || [];
    const tickers = await mapTagToTicker([
      ...new Set([...entitiesTags, data.info?.name || '']),
    ]);
    name = data.info.name ? tickers[data.info?.name] || data.info.name : name;
    entities = entitiesTags.map(e => tickers[e] || e).join(', ');
    count = entitiesTags.length ? 1 : 0;
  }
  return { entities, name, count, entitiesTags };
};
